import { render, staticRenderFns } from "./ModalSocorroRota.vue?vue&type=template&id=229c27e8&scoped=true&"
import script from "./ModalSocorroRota.vue?vue&type=script&lang=js&"
export * from "./ModalSocorroRota.vue?vue&type=script&lang=js&"
import style0 from "./ModalSocorroRota.vue?vue&type=style&index=0&id=229c27e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229c27e8",
  null
  
)

export default component.exports